import React from 'react';
import PropTypes from 'prop-types';
import AppsBanner from '../../components/AppsBanner';
import Categories from '../../components/Categories';
import QuickLinksFragment from '../../components/QuickLinksFragment';
import RecommendedRow from '../../components/RecommendedRow';
import fireBatchedImpressions from '../../lib/BatchImpressions';

class Main extends React.Component {
  componentDidMount = () => {
    const links = this.getImpressionLinks();
    const { toolTileProps: { app: { csrf = '' } = {} } = {} } = this.props;
    fireBatchedImpressions(links, csrf);
  };

  getImpressionLinks = () => {
    const links = [];
    const {
      structuredPSData: {
        content: { PSImpressionUrl = '' },
        categories = []
      } = {}
    } = this.props;
    links.push(PSImpressionUrl);
    categories.forEach(({ content = {}, featured = [] }) => {
      links.push(content.PSImpressionUrl);
      featured.forEach(({ PSImpressionUrl = '' }) => {
        links.push(PSImpressionUrl);
      });
    });
    return links;
  };

  renderYourRecommendations = () => {
    const {
      fptiClick,
      fptiImpression,
      toolTileProps,
      defaultRecommended = []
    } = this.props;
    const { flatPSData: { recommended = [] } = {} } = toolTileProps;
    return (
      <div id="appcenter-categories">
        <RecommendedRow
          content={recommended[0]}
          featured={defaultRecommended}
          fptiClick={fptiClick}
          fptiImpression={fptiImpression}
          toolTileProps={toolTileProps}
        />
      </div>
    );
  };

  render() {
    const {
      structuredPSData: { content = {}, categories = [] } = {},
      fptiClick,
      fptiImpression,
      toolTileProps = {}
    } = this.props;

    return (
      <div id="appcenter-main">
        <AppsBanner content={content} />
        {toolTileProps.app.fptiData.lgin && this.renderYourRecommendations()}
        {toolTileProps.app.deviceInfo.isDesktop && <QuickLinksFragment />}
        <Categories
          categories={categories}
          viewAllText={content.viewDetails}
          fptiClick={fptiClick}
          fptiImpression={fptiImpression}
          toolTileProps={toolTileProps}
        />
      </div>
    );
  }
}

Main.displayName = 'main';

Main.propTypes = {
  categories: PropTypes.array,
  ps: PropTypes.object,
  structuredPSData: PropTypes.object,
  fptiClick: PropTypes.func,
  fptiImpression: PropTypes.func,
  toolTileProps: PropTypes.object,
  defaultRecommended: PropTypes.array
};

export default Main;
